import { render } from "./LegalBanner.vue?vue&type=template&id=32ef0772&scoped=true"
const script = {}

import "./LegalBanner.vue?vue&type=style&index=0&id=32ef0772&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ef0772"]])

export default __exports__